export default __webpack_public_path__ + "static/media/1.c932c1d0.svg";